// Relative import with an explicit extension so Node's built-in test runner can load this
// file without a bundler (see `yarn test`); Vite and tsc accept the same path.
import {
  MIXPANEL_ACCESS_METHOD,
  type MixpanelAccessMethod,
} from "../constants/analyticsTracking.ts";

/**
 * OP-3133: `access_method` says how the user reached a lesson — through a
 * lesson's Pretty URL (direct link) or from inside the app. Always present so
 * the Mixpanel filter never shows "(not set)".
 */
export const mixpanelAccessProps = (
  accessMethod?: MixpanelAccessMethod | string | null,
): { access_method: string } => ({
  access_method: accessMethod || MIXPANEL_ACCESS_METHOD.APP,
});

export const isPrettyUrlAccess = (
  accessMethod?: MixpanelAccessMethod | string | null,
): boolean => accessMethod === MIXPANEL_ACCESS_METHOD.PRETTY_URL;
